import roles from 'helpers/roles';
import Notes from 'components/Notes/Notes';
import CardBody from 'components/Card/CardBody.jsx';
import CardWrapper from 'components/Card/CardWrapper';

const NotesRecipeForm = ({ recipeId }) => (
  <CardWrapper>
    <CardBody>
      <Notes
        urlParam={`/recipes/${recipeId}`}
        notePermission={roles.ROLE_NOTE_RECIPE}
      />
    </CardBody>
  </CardWrapper>
);

export default NotesRecipeForm;
